import { useEffect } from "react";

const SITE_URL = "https://lulosoftware.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [a, n] = selector.replace(/^meta\[|]$/g, "").split("=");
    el.setAttribute(a, n.replace(/['"]/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useDocTitle — drives all per-page SEO metadata.
 * Backwards compatible signature: useDocTitle(title, description, keywords?, path?)
 */
export default function useDocTitle(title, description, keywords, path) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }

    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }

    if (keywords) {
      setMeta('meta[name="keywords"]', "content", keywords);
    }

    const url = path ? `${SITE_URL}${path}` : `${SITE_URL}${window.location.pathname}`;
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:site_name"]', "content", "Lulo Software");
    setMeta('meta[property="og:image"]', "content", DEFAULT_OG_IMAGE);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:image"]', "content", DEFAULT_OG_IMAGE);
    setLink("canonical", url);
  }, [title, description, keywords, path]);
}
